import { useEffect, useRef, useState } from "react";
import { GoSearch } from "react-icons/go";
import { Nav } from 'rsuite';
import { FiPhoneCall } from "react-icons/fi";
import { FaCreditCard } from "react-icons/fa6";
import { FaPeopleGroup } from "react-icons/fa6";
import ReportTabComponent from "../ReportTabComponent";
import { IoMdCloseCircle } from "react-icons/io";
import ModalComponent from "../CommonComponents/Modal";

const ExportReport = (props) => {
    const searchInputRef = useRef();

    const {
        openReportPopup,
        onSearch,
        searchTerm,
        visibleReportHeaders,
        handleCheckboxChange,
        active,
        setActive,
        onTabChange,
        genInfoCols,
        generalInfoCheckedItems,
        cardAcceptanceInfoCheckedItems,
        listSupplierInfoCheckedItems,
        xPos,
        yPos,
        setopenReportPopup,
        childInfoCols,
        listSupplierInfoCols,
        childInfoCheckedItems,
        subGeneralBtnActive,
        onChangeActiveGeneralInfo,
        primarySupplier,
        headerModal,
        setHeaderModal,
        backdrop,
        onSelectedHeaders,
        onNotselectedHeaders,
        onCloseReportHeader,
        cardAccInfoCols } = props;

    const Navbar = ({ active, onSelect, ...props }) => {
        return (
            <div className="d-flex justify-content-between" style={{ marginLeft: 5, width: '97%', marginBottom: 5 }}>
                <button className="btn btn-large btn-light border" style={{ height: 30, width: '47%', backgroundColor: "#f8f9fa" }} onClick={() => { onTabChange('generalInfo') }}><FaPeopleGroup size={16} color={`${active === 'generalInfo' ? '#214466' : 'black'}`} /></button>
                <button className="btn btn-large btn-light border" style={{ height: 30, width: '47%', backgroundColor: "#f8f9fa" }} onClick={() => { onTabChange('cardAcceptances') }} ><FaCreditCard size={16} color={`${active === 'cardAcceptances' ? '#214466' : 'black'}`} /></button>
            </div>
        );
    };

    const [generalInfoCols, setGeneralInfoCols] = useState([])
    const [childGenInfoCols, setChildGenInfoCols] = useState([])
    const [listSupInfoCols, setListSupInfoCols] = useState([])
    const [cardAcceptanceInfoCols, setCardAcceptanceInfoCols] = useState([])

    useEffect(() => {
        setGeneralInfoCols(genInfoCols || [])
        setChildGenInfoCols(childInfoCols || [])
        setListSupInfoCols(listSupplierInfoCols || [])
        setCardAcceptanceInfoCols(cardAccInfoCols || [])
    }, [genInfoCols, childInfoCols, listSupplierInfoCols, cardAccInfoCols])

    useEffect(() => {
        searchInputRef.current && searchInputRef.current.focus()
    }, [openReportPopup])

    return (
        <div
            className="report-pop-out position-absolute"
            style={{
                top: "15%",
                left: "44%"
            }}
        >
            <div
                className="border rounded"
                hidden={openReportPopup}
                style={{
                    height: 647,
                    width: 350,
                    position: 'absolute',
                    zIndex: 1000,
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    padding: '10px 20px'

                }}
            >
                <ModalComponent
                    backdrop={backdrop}
                    open={headerModal}
                    handleClose={() => { setHeaderModal(false) }}
                    modalTitle={`Report Header Confirmation`}
                    size={`md`}
                >
                    <h4 className="font-weight-bold">Do you want to save the selected headers?</h4>
                    <div className=" d-flex column-gap-3 mt-2">
                        <button className="report_button_secondary" style={{ width: 130 }} onClick={onNotselectedHeaders}>No</button>
                        <button className="report_button_success pl-2 pr-2" style={{ width: 130 }} onClick={onSelectedHeaders}>Yes And Run</button>
                    </div>
                </ModalComponent>
                <div className="p-2" style={{ height: 60 }} >
                    <div className="d-flex justify-content-between ">
                        <h4 className="fs-5 p-1">Customize Columns</h4>
                        <IoMdCloseCircle size={20} onClick={onCloseReportHeader} />
                    </div>
                    <div className="input-group mb-3" style={{ height: 30 }}>
                        <span className="input-group-text" id="basic-addon1"><GoSearch /></span>
                        <input
                            ref={searchInputRef}
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            onChange={onSearch}
                            value={searchTerm || ''}
                        />
                    </div>
                </div>
                <div className="" style={{ height: 200 }}>
                    <h6 className="fw-bold input-group-text" style={{ height: 30, width: "97%", marginLeft: 5, marginTop: 10, marginBottom: 10 }}>VISIBLE</h6>
                    <div style={{ height: 148, overflowY: 'scroll', marginLeft: 5, width: '97%' }}>
                        <div className="px-4 py-3" >
                            {visibleReportHeaders?.map((item, index) => {
                                return (
                                    <div key={index} className="d-flex align-items-center column-gap-3 mb-2">
                                        <input
                                            type="checkbox"
                                            name={item.name}
                                            checked={item.checked}
                                            onChange={(e) => { handleCheckboxChange(e, item, 'visible') }}
                                            style={{ width: 14, height: 14, }}
                                        />
                                        <label htmlFor={item.name} style={{ fontSize: 11 }}>{item.label}</label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{ height: `${active === 'generalInfo' ? '100px' : '70px'}` }}>
                        <div>
                            <h6 className="fw-bold input-group-text d-flex justify-content-between" style={{ width: "97%", marginLeft: "5px", height: 30 }}>AVAILABLE </h6>

                        </div>
                        <Navbar appearance="tabs" active={active} onSelect={setActive} primarySupplier={primarySupplier} />
                        {active === 'generalInfo' && <div className="d-flex justify-content-between p-1 mt-4" style={{ width: '97%', marginLeft: '5px', gap: '15px' }}>
                            <button
                                className={`${subGeneralBtnActive === 'master' ? "report_selected_subheader" : "report_unselected_subheader"}`}
                                style={{ textAlign: 'center' }}
                                onClick={() => { onChangeActiveGeneralInfo('master') }}
                            >
                                Master Supplier
                            </button>
                            {primarySupplier === "listSupplier" ? null : <button
                                className={`${subGeneralBtnActive === 'child' ? "report_selected_subheader" : "report_unselected_subheader"}`}
                                style={{ textAlign: 'center' }}
                                onClick={() => { onChangeActiveGeneralInfo('child') }}
                            >
                                Child Supplier
                            </button>}
                            {primarySupplier === "masterSupplier" || primarySupplier === "childSupplier" ? null : <button
                                className={`${subGeneralBtnActive === 'listSupplier' ? "report_selected_subheader" : "report_unselected_subheader"}`}
                                style={{ textAlign: 'center' }}
                                onClick={() => { onChangeActiveGeneralInfo('listSupplier') }}
                            >
                                List Supplier
                            </button>}
                        </div>}
                    </div>
                    {(active === 'generalInfo' && subGeneralBtnActive === 'master') &&
                        <ReportTabComponent
                            category={generalInfoCols}
                            handleCheckboxChange={handleCheckboxChange}
                            subGeneralBtnActive={subGeneralBtnActive}
                            active={active}
                            tab='master'
                            searchTerm={searchTerm}
                        />}
                    {(active === 'generalInfo' && subGeneralBtnActive === 'child') &&
                        <ReportTabComponent
                            category={childGenInfoCols}
                            handleCheckboxChange={handleCheckboxChange}
                            subGeneralBtnActive={subGeneralBtnActive}
                            active={active}
                            tab='child'
                            searchTerm={searchTerm}
                        />}
                    {(active === 'generalInfo' && subGeneralBtnActive === 'listSupplier') && <ReportTabComponent
                        category={listSupInfoCols}
                        handleCheckboxChange={handleCheckboxChange}
                        active={active}
                        tab='listSupplier'
                        searchTerm={searchTerm}
                    />}

                    {
                        active === 'cardAcceptances' && <ReportTabComponent
                            category={cardAcceptanceInfoCols}
                            handleCheckboxChange={handleCheckboxChange}
                            active={active}
                            tab='cardAcceptances'
                            searchTerm={searchTerm}
                        />
                    }
                </div>
                <div className="d-flex justify-content-end">
                    <button className="report_confirm w-25 mt-3" style={{ height: 30 }} disabled={primarySupplier ? false : true} onClick={() => { onSelectedHeaders() }}>Confirm</button>
                </div>
            </div>
        </div>
    )
}

export default ExportReport;